import React from "react";
import { useNavigate } from "react-router-dom";
import { useBodyMeasurementServiceContext } from "../../../contexts/BodyMeasurementServiceContext";
import { BODY_MEASUREMENT_SERVICE_STEPS as steps } from "../../../utilities/defaults/free-trial/body-measurement-service-steps";
import MainButton from "../../button/MainButton";
import { ArrowLeft, ArrowRight, Refresh2 } from "iconsax-react";

interface PaginationProps {
  handlerButtonText?: string;
  isInMeasurement?: boolean;
  isMeasurementSuccessed?: boolean;
}

const BodyMeasurementServicePagination: React.FC<PaginationProps> = ({ handlerButtonText = "Continue", isInMeasurement = false, isMeasurementSuccessed = false }) => {
  const { resetBodyMeasurementService, resetSizeGuide, canProceedToNextStep, currentStep, handlePageChange } = useBodyMeasurementServiceContext();

  const navigate = useNavigate();

  const handlePrevPage = () => {
    resetSizeGuide();

    if (currentStep > 0) {
      handlePageChange(isMeasurementSuccessed ? currentStep - 2 : currentStep - 1);
    }
  };

  const handleNextPage = () => {
    if (isMeasurementSuccessed) {
      resetSizeGuide();
      resetBodyMeasurementService();
      navigate("/dashboard/free-trial/body-measurment");
      return;
    }

    if (currentStep < steps.length - 1 && canProceedToNextStep) {
      handlePageChange(currentStep + 1);
    }
  };

  return (
    <div className="flex justify-between w-full gap-4">
      <MainButton type="secondary" onClick={handlePrevPage} disabled={currentStep === 0}>
        <ArrowLeft variant="Broken" />
        Previous
      </MainButton>

      <MainButton type="primary" onClick={handleNextPage} disabled={!canProceedToNextStep} customClass={`${isInMeasurement ? "animate-pulse" : ""}`}>
        {handlerButtonText}
        {isMeasurementSuccessed ? <Refresh2 variant="Broken" /> : <ArrowRight variant="Broken" />}
      </MainButton>
    </div>
  );
};

export default BodyMeasurementServicePagination;
